import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import {
  AddBrandApi,
  AddCategoryToBrandApi,
  AddImeiDetailsApi,
  AddProductToCategoryApi,
  AddTicketApi,
  baseurl,
  GetImeiDetailsApi,
  getProfileApi,
  GetSubUserProfileApi,
  SetLimitCheckApi,
} from "../Utility/Api";
import DefaultServiceModel from "./DefaultServiceModel";

const SelectServiceModal = (props) => {
  const [showModal, setShowModel] = useState(false);
  const [showModal1, setShowModel1] = useState(false);

  const [defaultServices, setDefaultServices] = useState([]);

  const [loading, setLoading] = useState(false);
  const [expandedCategoryIndex, setExpandedCategoryIndex] = useState(0);
  const [categoryName, setCategoryName] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [subcategoryName, setSubcategoryName] = useState("");
  const [subcategoryNames, setSubcategoryNames] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [subcategoryId, setSubcategoryId] = useState("");
  const [editedFields, setEditedFields] = useState({});

  const [adminState, setAdminState] = useState("");
  const [selectedSubcategories, setSelectedSubcategories] = useState({});
  const [searchInput, setSearchInput] = useState("");
  const [showAddModelModal2, setShowAddModelModal2] = useState(false);
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [price, setPrice] = useState();
  const [editIndex, setEditIndex] = useState(null);
  const [step1, setStep1] = useState(1);

  const handleNext = () => {
    setStep1(2); // Show SelectDeviceModal content
  };

  const handleBack = () => {
    setStep1(1); // Go back to CreateTicket
  };

  const handleCloseAll = () => {
    // props?.onpress(); // Close parent modal
    setStep1(1); // Reset step
  };

  const isSubcategorySelected = (categoryId, subId) => {
    return selectedSubcategories[`${categoryId}_${subId}`];
  };
  const handleSubcategorySelect = (category, subcategory) => {
    const key = `${category.id}_${subcategory.id}`;

    setSelectedSubcategories((prev) => {
      const newSelection = {
        ...prev,
        [key]: !prev[key],
      };

      updateSelectedServices(category, subcategory, !prev[key], newSelection);
      return newSelection;
    });
  };
  const updateSelectedServices = (
    category,
    subcategory,
    isSelected,
    selectedMap
  ) => {
    setSelectedServices((prev) => {
      let updated = [...prev];

      const existsIndex = updated.findIndex(
        (item) =>
          item.categoryId === category.id &&
          item.subCategoryId === subcategory.id
      );

      if (isSelected && existsIndex === -1) {
        updated.push({
          categoryId: category.id,
          category: category.category,
          subCategoryId: subcategory.id,
          subCategory: subcategory.name,
          quantity: 1,
          price: subcategory.price,
          stock: subcategory.stock,
        });
      } else if (!isSelected && existsIndex !== -1) {
        updated.splice(existsIndex, 1);
      }

      return updated;
    });
  };

  // const handleSubcategorySelect = (category, subcategory) => {
  //   const key = `${category.id}_${subcategory.id}`;
  //   setSelectedSubcategories((prev) => ({
  //     ...prev,
  //     [key]: !prev[key],
  //   }));

  //   // Optional: Update selectedServices array if needed
  // };

  const navigate = useNavigate();

  const handleCategoryClick = (index) => {
    setExpandedCategoryIndex((prevIndex) =>
      prevIndex === index ? null : index
    );
  };

  useEffect(() => {
    console.log("new select services props", props);
    let localAdmin = localStorage.getItem("admin");

    setAdminState(localAdmin);
    GetAllDefaultServices();
  }, []);

  const GetAllDefaultServices = () => {
    const userid = localStorage.getItem("userId");
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getDefaultServices`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status && result.data?.length > 0) {
          setDefaultServices(result.data[0].services);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const AddSubCategory = () => {
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      categoryId: selectedCategoryId,
      subcategory: subcategoryName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}addsubcategory`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        GetAllDefaultServices();
        setShowModel1(false);
      })
      .catch((error) => console.error(error));
  };

  const AddCategory = () => {
    let local = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      category: categoryName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}addCategory`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //  console.log(result);
        GetAllDefaultServices();

        setShowModel(false); // Close modal on success
        setCategoryName(""); // Reset input
      })
      .catch((error) => console.error(error));
  };

  const UpdateSubCategory = () => {
    let local = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      updatedService: {
        categoryId: selectedCategoryId,
        subcategoryId: subcategoryId,
        newSubcategoryName: subcategoryName,
      },
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}updateDefaultServices`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //console.log(result);
        GetAllDefaultServices(); // Refresh list
        setShowModel1(false); // Close modal
        setSubcategoryName(""); // Clear input
        setIsEditMode(false); // Reset input
      })
      .catch((error) => console.error(error));
  };

  const handleSaveChanges = () => {
    let local = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const updates = Object.values(editedFields).map((update) => {
      const { price = 0, cost = 0, stock = 0 } = update;
      const profit = price - cost;
      const margin = price !== 0 ? Math.round((profit / price) * 100) : 0;

      return {
        ...update,
        profit,
        margin,
        stock: Number(stock),
        cost: Number(cost),
        price: Number(price),
      };
    });

    updates.forEach((update) => {
      const raw = JSON.stringify({
        updatedService: update,
      });

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      console.log("uddafsd", raw);

      fetch(`${baseurl}updateDefaultServices`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log("Updated:", result);
          GetAllDefaultServices();
        })
        .catch((error) => console.error("Error updating:", error));
    });

    //   alert("All updates sent!");
    //   setEditedFields({});
  };

  const AddTicket = () => {
    const serviceId1Data = [];

    filteredServices.forEach((categoryItem, index) => {
      const selectedSubItems = categoryItem.subcategories?.filter(
        (subItem) => selectedSubcategories[`${categoryItem.id}_${subItem.id}`]
      );

      if (selectedSubItems?.length > 0) {
        serviceId1Data.push({
          id: categoryItem.id,
          name: categoryItem.category,
          subcategories: selectedSubItems.map((subItem) => {
            const matchedService = selectedServices.find(
              (service) =>
                service.categoryId === categoryItem.id &&
                service.subCategoryId === subItem.id
            );

            const quantity = matchedService?.quantity || 1;
            const total = matchedService ? matchedService.price * quantity : 0;

            return {
              id: subItem.id,
              name: subItem.name,
              stock: subItem.stock,
              price: subItem.price,
              editPrice: Number(
                selectedServices.find(
                  (s) =>
                    s.categoryId === categoryItem.id &&
                    s.subCategoryId === subItem.id
                )?.price ?? subItem.price
              ),

              quantity,
              total: parseFloat(total.toFixed(2)),
            };
          }),
        });
      }
    });

    console.log("Selected Services Payload:", serviceId1Data);

    if (!props?.prop?.customer && serviceId1Data.length === 0) {
      Swal.fire({
        title: "Please select Customer and at least one Service.",
        customClass: {
          container: "custom-swal-container",
          confirmButton: "custom-swal-confirm-button",
        },
      });
      return;
    }

    if (!props?.prop?.customer) {
      Swal.fire({
        title: "Please select Customer.",
        customClass: {
          container: "custom-swal-container",
          confirmButton: "custom-swal-confirm-button",
        },
      });
      return;
    }

    if (serviceId1Data.length === 0) {
      Swal.fire({
        title: "Please select at least one Service.",
        customClass: {
          container: "custom-swal-container",
          confirmButton: "custom-swal-confirm-button",
        },
      });
      return;
    }

    setLoading(true);
    let local = localStorage.getItem("token");
    let userid = localStorage.getItem("userId");
    let subuserid = localStorage.getItem("subuserId");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      customerId: props?.prop?.customer,
      customerDeviceId: props?.productid,
      brandId: props?.brandid,
      serviceId1: serviceId1Data,
      categoryId: props?.seriesid,
      serviceId2: 0,
      statusOptionId: props?.prop?.status,
      techAssignedId: adminState === "0" ? subuserid : userid,
      salesPersonId: adminState === "0" ? subuserid : userid,
      dueDate: props?.prop?.date,
      password: props?.prop?.password,
      description: props?.prop?.note,
      drivingLicence: props?.prop?.driver,

      bin: props?.prop?.binid,

      isAdmin: adminState,
      isTechAdmin: adminState,
      isSalesPersonAdmin: adminState,
      techAssignedName: props?.prop?.assigned,
      repairTaskType: props?.prop?.repairid,
      warrantyApplicable: props?.prop?.warrantyid,
      imeiOrSerial: props?.prop?.imei,
      pattern: {
        patternType: "patteren",
        patternValue: props?.prop?.patteren,
      },
      image: props?.prop?.imageurl,
      preRepairChecklist: props?.prop?.checklist,
      additionalInfo: props?.prop?.additional,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    console.log("adddticket raww", raw);

    fetch(AddTicketApi, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("ticket add result", result);
        if (result?.status === true) {
          document
            .querySelectorAll(".modal-backdrop")
            .forEach((el) => el.classList.remove("modal-backdrop"));
          props.onpress();
          props?.prop?.onPress();
          props?.prop?.cretae();
          //   document
          //     .querySelectorAll(".modal-backdrop")
          //     .forEach((el) => el.classList.remove("modal-backdrop"));
          // props.onpress(false);
          navigate("/ticketdetail", { state: { data: result?.data } });
          props.onload();
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        // setLoading(false);
      });
  };



  const updateQuantity = (index, value) => {
    // Ensure the value is a valid number and update the quantity
    const newQuantity = parseInt(value, 10) > 0 ? parseInt(value, 10) : 1; // Default to 1 if value is invalid
    const updatedServices = [...selectedServices];
    updatedServices[index].quantity = newQuantity;
    setSelectedServices(updatedServices); // Update the state
  };

  const removeService = (index) => {
    setSelectedServices((prev) => {
      const updated = [...prev];
      const removedService = updated.splice(index, 1)[0];

      // Uncheck the subcategory in the checkbox map
      setSelectedSubcategories((prevSubcategories) => {
        const newSubcategories = { ...prevSubcategories };
        const key = `${removedService.categoryId}_${removedService.subCategoryId}`;
        delete newSubcategories[key]; // uncheck
        return newSubcategories;
      });

      return updated;
    });
  };


  const filteredServices = defaultServices.filter((service) => {
    const categoryMatch = service.category
      .toLowerCase()
      .includes(searchInput.toLowerCase());

    const subcategoryMatch = service.subcategories?.some((sub) =>
      sub.name?.toLowerCase().includes(searchInput.toLowerCase())
    );

    return categoryMatch || subcategoryMatch;
  });

  const OnPress = () => {
    setShowAddModelModal2(false);
  };

  const OnLoad = () => {
    GetAllDefaultServices();
  };

  return (
    <>
      {step1 === 1 ? (
        <>
          <div
            className="modal-dialog modal-dialog-centered cusmodal_xl"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="selectserviceModalLabel">
                  Select Service
                </h5>
                <button
                  type="button"
                  style={{ marginLeft: "10px" }}
                  className="close"
                  // data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    props?.onpress();
                    props?.onClose1();
                    //  props?.onBack1()
                    document
                      .querySelectorAll(".modal-backdrop")
                      .forEach((el) => el.classList.remove("modal-backdrop"));
                  }}
                >
                  <span className="close_icon" />
                </button>
                <button
                  className="manage_service_btn"
                  type="button"
                  onClick={(e) => {
                    handleNext();
                    document
                      .querySelectorAll(".modal-backdrop")
                      .forEach((el) => el.classList.remove("modal-backdrop"));
                    e.preventDefault(); // prevent default navigation
                    setShowAddModelModal2(true);
                  }}
                >
                  <img src="assets/img/repair-edit-service-icon.png" alt="" />
                  Edit Repairs Prices
                </button>
                <div className="clearfix" />
                <div className="device_service_action">
                  <p>Device:</p>
                  <div className="brand_model_name">
                    <span>
                      ({props?.Brand}) &amp; ({props?.product})
                    </span>
                  </div>
                  <div className="service_change">
                    <a
                      href="#"
                      onClick={() => {
                        props?.onpress();
                        props?.onBack1();
                      }}
                    >
                      <img src="assets/img/service-edit-action.png" alt="" />{" "}
                      Change
                    </a>
                  </div>
                </div>
              </div>
              <div className="modal-body">
                <div className="custom_form manage_service_form">
                  <form
                    action=""
                    method=""
                    className="cus_form"
                    data-gtm-form-interact-id={0}
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="cus_device_search">
                          <div className="search_field">
                            <input
                              type="text"
                              className="form-control"
                              name="brandsearch"
                              placeholder="Search Service"
                              value={searchInput}
                              onChange={(e) => setSearchInput(e.target.value)}
                            />
                            <div className="search_icon">
                              <img
                                src="assets/img/repair-deivce-search-icon.png"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="select_service_list">
                          <div className="select_service_left">
                            <div className="servicelist">
                              {filteredServices?.map((service, index) => {
                                const subcategories =
                                  service.subcategories || [];
                                // const prices = subcategories.map(
                                //   (sub) => sub.price || 0
                                // );
                                const prices =
                                  subcategories.length > 0
                                    ? subcategories.map((sub) => sub.price || 0)
                                    : [0];
                                const minPrice = Math.min(...prices);
                                const maxPrice = Math.max(...prices);
                                const totalStock = subcategories.reduce(
                                  (acc, sub) => acc + (sub.stock || 0),
                                  0
                                );

                                return (
                                  <div className="service_col" key={service.id}>
                                    <div
                                      className="innner_service_col"
                                      onClick={() => {
                                        setActiveCategoryId((prevId) =>
                                          prevId === service.id
                                            ? null
                                            : service.id
                                        );
                                      }}
                                      // onClick={() =>
                                      //   setActiveCategoryId(service.id)
                                      // }
                                    >
                                      <div className="servicename">
                                        <span>{service.category}</span>
                                      </div>
                                      <div className="serviceprice">
                                        <span>
                                          ${minPrice.toFixed(2)}-$
                                          {maxPrice.toFixed(2)}
                                        </span>
                                      </div>
                                      <div className="servicevarient">
                                        <span>{totalStock} in Stock</span> for{" "}
                                        {subcategories.length} variants
                                      </div>
                                    </div>

                                    {activeCategoryId === service.id &&
                                      subcategories.length > 0 && (
                                        <div className="service_table_data">
                                          <table>
                                            <tbody>
                                              {subcategories.map(
                                                (sub, subIndex) => (
                                                  <tr key={subIndex}>
                                                    <td>{sub.name}</td>
                                                    <td>
                                                      {sub.stock || 0} stock
                                                    </td>
                                                    <td>
                                                      $
                                                      {(sub.price || 0).toFixed(
                                                        2
                                                      )}
                                                    </td>
                                                    <td>
                                                      <div className="checkbox">
                                                        <input
                                                          type="checkbox"
                                                          checked={isSubcategorySelected(
                                                            service.id,
                                                            sub.id
                                                          )}
                                                          onChange={() =>
                                                            handleSubcategorySelect(
                                                              service,
                                                              sub
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className="select_service_right">
                            <div className="service_item_title">
                              <span>Selected Services</span>
                            </div>
                            <div className="service_item_table">
                              <table>
                                <tbody>
                                  {selectedServices.map((service, index) => (
                                    <tr key={index}>
                                      <td className="item_name">
                                        {service.category}{" "}
                                        <span>{service.subCategory}</span>
                                      </td>
                                      <td className="item_qty">
                                        <div className="quantity_field">
                                          <a
                                            href="#"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              const newQty = Math.max(
                                                1,
                                                service.quantity - 1
                                              );
                                              updateQuantity(index, newQty);
                                            }}
                                          >
                                            <img
                                              src="assets/img/service-qty-minus-icon.png"
                                              alt="Minus"
                                            />
                                          </a>
                                          <div className="qty_input">
                                            <input
                                              type="number"
                                              className="form-control no-arrow-input"
                                              name="service_qty"
                                              value={service.quantity}
                                              readOnly // Disallow manual editing
                                            />
                                          </div>
                                          <a
                                            href="#"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              const newQty =
                                                service.quantity + 1;
                                              updateQuantity(index, newQty);
                                            }}
                                          >
                                            <img
                                              src="assets/img/service-qty-plus-icon.png"
                                              alt="Plus"
                                            />
                                          </a>
                                        </div>
                                      </td>

                                     
                                      <td className="item_price">
                                        $
                                        {(
                                          service.price * service.quantity
                                        ).toFixed(2)}
                                      </td>
                                      <td className="item_action">
                                        <div className="action_btns">
                                          <a
                                            href="#"
                                            className="repedit_btn"
                                            onClick={(e) => {
                                              e.stopPropagation();

                                              e.preventDefault();
                                              setShowModel1(true);
                                              setIsEditMode(true);
                                              // setPrice(
                                              //   parseFloat(
                                              //     selectedServices[index].price *
                                              //       service.quantity
                                              //   )
                                              // );
                                              setPrice(
                                                selectedServices[index].price
                                              );
                                              // Set existing price
                                              setEditIndex(index);
                                              // setSubcategoryName(subItem.name); // Pre-fill name
                                              //setSubcategoryId(subItem.id); // Set subcategory ID for update
                                              // setSelectedCategoryId(
                                              //   categoryItem.id
                                              // ); // Set selected category
                                              setSubcategoryNames("Issue"); // For modal title
                                            }}
                                          >
                                            <img
                                              src="assets/img/repair-edit-action-icon.png"
                                              alt=""
                                            />
                                          </a>
                                          <a
                                            href="#"
                                            className="reptrash_btn"
                                            onClick={() => removeService(index)}
                                          >
                                            <img
                                              src="assets/img/repair-trash-action-icon.png"
                                              alt=""
                                            />
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary cancel_btn mr-auto"
                    // data-dismiss="modal"
                    onClick={() => {
                      props?.onpress();
                      props?.onBack1();
                    }}
                  >
                    Back
                  </button>
                  {/* <button type="button" className="btn btn-secondary skip_btn">
                Skip
              </button> */}
                  <button
                    type="button"
                    className="btn btn-primary success_btn"
                    onClick={() => AddTicket()}
                  >
                    Create Service
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {showAddModelModal2 && (
            <div
              className="modal show d-block common_modal editrepairproduct_modal cus_repair_modal"
              id="editrepairproductModal"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="editrepairproductModalLabel"
              aria-hidden="true"
            >
              <DefaultServiceModel
                product={props?.product}
                Brand={props?.Brand}
                series={props?.series}
                onpress={OnPress}
                onload={OnLoad}
                // prop={props}
                brandid={props?.brandid}
                productid={props?.productid}
                seriesid={selectedCategoryId}
                onBack1={handleBack}
                onClose1={handleCloseAll}
                onNext={handleNext}
              />
            </div>
          )}
        </>
      )}

      {showModal1 && (
        <>
          <div
            className="modal show d-block common_modal editrepairservice_modal cus_repair_modal"
            id="editrepairserviceModal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="editrepairserviceModalLabel"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered cusmodal_sm"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="editrepairserviceModalLabel">
                    Edit Price
                  </h5>
                  <button
                    type="button"
                    className="close"
                    // data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setShowModel1(false);
                      setIsEditMode(false);
                      setSubcategoryName("");
                    }}
                  >
                    <span className="close_icon" />
                  </button>
                </div>
                <div className="modal-body">
                  <div className="custom_form addcustom_form">
                    <form
                      action=""
                      method=""
                      className="cus_form"
                      data-gtm-form-interact-id={0}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form_column col_full">
                            <div className="form-group">
                              <label className="cus_label">
                                Price<span>*</span>
                              </label>
                              <div className="formfield selectcustomerboxcustmlist">
                                <input
                                  type="number"
                                  name="issuename"
                                  className="form-control  no-arrow-input"
                                  placeholder="Enter Price"
                                  value={price}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (!isNaN(val) && parseFloat(val) >= 0) {
                                      setPrice(val);
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="submit_modal_btn">
                        <button
                          type="button"
                          className="btn btn-default cancel_btn"
                          onClick={() => {
                            setShowModel1(false);
                            setIsEditMode(false);
                            setPrice(null);
                            setEditIndex(null);
                          }}
                          //   data-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary theme_btn"
                          onClick={() => {
                            if (editIndex !== null && !isNaN(price)) {
                              const updated = [...selectedServices];
                              updated[editIndex].price = price;
                              setSelectedServices(updated);
                              setShowModel1(false);
                              setEditIndex(null);
                              setIsEditMode(false);
                            }
                          }}
                          // onClick={() => {
                          //   handleSaveChanges();
                          //   // if (isEditMode) {
                          //   //   UpdateSubCategory(); // Call update API
                          //   // } else {
                          //   //   AddSubCategory(); // Existing function for adding
                          //   // }
                          // }}
                        >
                          Edit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default SelectServiceModal;
